import { SaveButton, TabbedForm, Toolbar, type TabbedFormProps } from "react-admin";
import { InvalidFieldsNotifier } from "./InvalidFieldsNotifier";

const LangToolbar = () => (
  <Toolbar>
    <SaveButton />
    <InvalidFieldsNotifier />
  </Toolbar>
);

export const LangTabbedForm = (props: TabbedFormProps) => (
  <TabbedForm
    syncWithLocation={false}
    shouldUnregister={false}
    disableInvalidFormNotification
    toolbar={<LangToolbar />}
    sx={{ "& .MuiTabPanel-root": { pt: 2 } }}
    {...props}
  />
);
